import styled from "styled-components";

const StyledMembersSubscribersDonutChart = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.iron};
	border-radius: 6px;
	padding: 16px;
	gap: 60px;
	width: 100%;
	flex-wrap: wrap;
	position: relative;

	.sb-members-subscribers-donut-chart {
		&__chart {
			flex: 1;
		}

		&__cards {
			flex: 1;
		}
	}
`;

export default StyledMembersSubscribersDonutChart;

